import WhatsappDataTable from "@pages/main/whatsapp_api/list/sub_components/whatsapp_data_table"

export default function WhatsappPage() {
  return (
    <>
      <WhatsappDataTable />
    </>
  )
}
